export default __webpack_public_path__ + "static/media/file-csv-solid.511802be.svg";